import React, { useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import i18next from "i18next";
import { TimelineContainer, Element, Header } from "./styles";
import * as agesApi from "../../services/ageServices";
import { IconButton } from "@mui/material";
import { KeyboardDoubleArrowUp, KeyboardDoubleArrowDown } from "@mui/icons-material";

type Props = {
	onReady?: () => void;
	setTimelineDisplayed?: (value: boolean) => void;
	visible?: boolean;
	setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
};

const buttonStyle = {
	"&:hover": {
		backgroundColor: "#41B5C3",
		color: "white",
	},
	boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.15)",
	position: "absolute",
	top: -60,
	zIndex: 1,
	backgroundColor: "white",
	left: "35px",
};

const Timeline = ({ onReady, visible = true, setVisible }: Props) => {
	const [timeLength, setTimeLength] = React.useState<number>(0);
	const [ages, setAges] = React.useState<any[]>([]);

	useEffect(() => {
		agesApi.getAges().then((res) => {
			let timeLength = 0;
			res?.forEach((system) => {
				let systemDur = 0;
				system.series.forEach((serie) => {
					let seriesDur = 0;
					serie.stages.forEach((stage) => {
						seriesDur += stage.bottom - stage.top;
						stage.stageDur = stage.bottom - stage.top;
						timeLength += stage.bottom - stage.top;
					});
					serie.serieDur = seriesDur;
					systemDur += seriesDur;
				});
				system.systemDur = systemDur;
			});

			setTimeLength(timeLength);
			setAges(res);
			onReady?.();
		});
	}, [onReady]);

	return (
		<TimelineContainer>
			<IconButton onClick={() => setVisible?.((prev) => !prev)} sx={buttonStyle}>
				{visible ? <KeyboardDoubleArrowDown /> : <KeyboardDoubleArrowUp />}
			</IconButton>
			{visible && (
				<>
					<Header>{i18next.t("geologic-time")}</Header>
					<div className="d-flex">
						{ages.map((system, index) => (
							<div
								key={system + index}
								style={{ width: `calc(100% * ${system.systemDur / timeLength})` }}
							>
								<Tooltip title={`${system.name}`}>
									<Element
										className="d-flex justify-content-center align-items-center"
										style={{
											backgroundColor: system.color,
											fontSize: 10,
										}}
									>
										{system.name}
									</Element>
								</Tooltip>

								<div className="d-flex">
									{system.series.map((serie, index) => (
										<div
											key={serie + index}
											style={{
												width: `calc(100% * ${serie.serieDur / system.systemDur})`,
												fontSize: 8,
											}}
										>
											<Tooltip title={`${serie.name}`}>
												<Element
													style={{
														backgroundColor: serie.color,
														width: `calc(${serie.serieDur} / 100%)`,
														paddingTop: 6,
													}}
												>
													{serie.name}
												</Element>
											</Tooltip>

											<div className="d-flex">
												{serie.stages.map((stage, index) => (
													<Tooltip title={`${stage.name}`} key={stage + index}>
														<Element
															style={{
																width: `calc(100% * ${
																	stage.stageDur / serie.serieDur
																})`,
																backgroundColor: stage.color,
																paddingTop: 6,
															}}
														>
															{stage.name}
														</Element>
													</Tooltip>
												))}
											</div>
										</div>
									))}
								</div>
							</div>
						))}
					</div>
				</>
			)}
		</TimelineContainer>
	);
};

export default Timeline;
